export default () => {
  const numbers = [590, 622, 652, 574, 582, 610, 662];
  return numbers[new Date().getDay()];
};
